import { render, staticRenderFns } from "./DashChartLoading.vue?vue&type=template&id=9b8e7d58"
import script from "./DashChartLoading.vue?vue&type=script&lang=js"
export * from "./DashChartLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports